import React, { useState } from 'react';
import AddCharge from '../AddEdit/AddCharge';
import EditCharge from '../AddEdit/EditCharge';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';
const ChargesTab = () => {
const [showAdd, setShowAdd] = useState(false);
const handleCloseAdd = () => setShowAdd(false);
const handleShowAdd = () => setShowAdd(true);

const [showEdit, setShowEdit] = useState(false);
const handleCloseEdit = () => setShowEdit(false);
const handleShowEdit = () => setShowEdit(true);

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="row">

                    <div className="col-md-6">
                        <label className="form-label">Issued At</label>
                        <div className="d-flex gap-2 flex-row">
                            <input type="Text" className="form-control form-control-sm custom-selector w-100" /> </div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Freight payable At</label>
                        <div className="d-flex gap-2 flex-row">
                            <input type="Text" className="form-control form-control-sm custom-selector w-100" /> </div>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Exporter Reference</label>
                        <textarea className="form-control  mt-1" rows="3"></textarea>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Importer Reference</label>
                        <textarea className="form-control  mt-1" rows="3"></textarea>
                    </div>

                    <div className="col-md-6 d-flex flex-row align-items-center">
                        <div className='ms-2 input_box_section w-100'>
                            <label htmlFor="" className='form-label mb-0'>
                                Show Freight
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0 d-flex align-items-center">
                                <input type="checkbox" className="form-check-input ms-2" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 d-flex align-items-center">
                        <div className='ms-2 input_box_section w-100'>
                            <label htmlFor="" className='form-label mb-0'>
                                Show Freight
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0 d-flex align-items-center">
                                <input type="Date" className="form-control form-control-sm " />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        {/* <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button">
                    Insert Default
                </button>

            </div>
        </div> */}

    </form>

</>
);
};

export default ChargesTab;